import { Link as ReactLink } from 'react-router-dom';
import { get } from 'lodash';
import { bool, object } from 'prop-types';
import * as paths from '../../config/paths';

import styled from 'styled-components';
import { colors } from '@podiumhq/podium-ui';

const TabAdmin = props => {
  const {
    skyhookCanAccessAutomations,
    skyhookCanAccessMarketplace,
    skyhookCanReadIntegrationsList,
    skyhookCanUseRogbot,
    skyhookCanViewFlock,
    skyhookCanViewPartner,
    currentUser,
    isLocationHome,
  } = props;

  const partnerUid = get(currentUser, 'partnerUid', null);
  const role = get(currentUser, 'roleSlug', '');

  const limitHeaderView = role === 'view_only_support' || role === 'support';

  return (
    <LinkContainer isLocationHome={isLocationHome}>
      {skyhookCanUseRogbot && <Link to={paths.ROGBOT_USERS}>Rogbot</Link>}
      {skyhookCanViewPartner && partnerUid ? null : (
        <Link to={paths.PHONE_LOOKUP}>Tools</Link>
      )}
      {(skyhookCanViewFlock || !limitHeaderView) && (
        <>
          {skyhookCanViewPartner && partnerUid ? null : (
            <Link to={paths.PARTNERS}>Partners</Link>
          )}
          {skyhookCanReadIntegrationsList && (
            <Link to={paths.INTEGRATIONS}>Integrations</Link>
          )}
        </>
      )}
      {skyhookCanAccessMarketplace && (
        <Link to={paths.MARKETPLACE}>Marketplace</Link>
      )}
      {skyhookCanAccessAutomations && (
        <Link to={paths.AUTOMATIONS}>Automations</Link>
      )}
    </LinkContainer>
  );
};

TabAdmin.propTypes = {
  skyhookCanAccessMarketplace: bool.isRequired,
  skyhookCanReadIntegrationsList: bool.isRequired,
  skyhookCanUseRogbot: bool.isRequired,
  skyhookCanViewFlock: bool.isRequired,
  skyhookCanViewPartner: bool.isRequired,
  currentUser: object.isRequired,
};

const LinkContainer = styled.div`
  padding-left: ${props => (props.isLocationHome ? '0' : '3rem')};

  @media (max-width: 977px) {
    position: absolute;
    top: 4rem;
    left: 2rem;
    width: 15rem;
    padding: 1rem;
    background: #565353;
    border-radius: 1rem;
    box-shadow: 0 0 10px;
    z-index: 1;
  }
`;

const Link = styled(ReactLink)`
  font-weight: 500;
  font-size: 14px;
  color: ${colors.white};
  cursor: pointer;
  margin: 0 12px;
  &:last-child {
    margin-right: 0px;
  }
  @media (max-width: 977px) {
    display: block;
    margin: 1rem 12px;
  }
`;

export default TabAdmin;
